// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kIL1","left":"styles_left__3jXxR"};